import Raven from 'raven-js';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CertificateImage as PrivateCertificateImage } from '../../../features/achievementImages';
import { addUrlParams } from 'LearningCenterUI/utils/RoutingUtils';
import { useAchievementTracks, usePublicAchievement, getMetadataLanguageFallback } from '../achievementQueries';
import ImageLoader from '../../../components/ImageLoader';
import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Hoverlay } from 'foundations-components/transitional/components/Hoverlay';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_BROCHURE_URL = 'https://academy.hubspot.com/courses';
const MarketingContainer = ({
  children
}) => /*#__PURE__*/_jsx(View, {
  borderRadius: "300",
  boxShadow: "400",
  marginBlockStart: "-1000",
  overflow: "hidden",
  children: children
});
const LegacyContainer = ({
  children
}) => {
  const {
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    borderRadius: "300",
    boxShadow: "400",
    marginBlockEnd: isTablet ? '0' : '-700',
    marginBlockStart: "-700",
    overflow: "hidden",
    children: children
  });
};
const handleImageError = ({
  currentTarget
}) => {
  Raven.captureMessage(`Achievements: error loading cert image`, {
    extra: {
      src: currentTarget.src
    }
  });
};
const CourseLink = ({
  href,
  trackEvent
}) => {
  return /*#__PURE__*/_jsx(Link, {
    "aria-label": I18n.text('learningCenter.certification.viewCourse'),
    "data-test-id": "achievement-cert-image",
    href: href,
    onClick: () => trackEvent({
      action: 'click-primary-cert',
      href,
      isExternalLink: false
    }),
    use: "on-dark",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.certification.viewCourse"
    })
  });
};
const CertificateImage = ({
  inModal,
  trackEvent,
  publicId,
  language
}) => {
  const {
    publicAchievement
  } = usePublicAchievement(publicId);
  const tracks = useAchievementTracks(publicId);
  const track = tracks ? tracks[0] : {
    id: null,
    award: {
      certificate: null
    }
  };
  const {
    id: trackId,
    award
  } = track;
  const src = award ? award.certificate : '';
  const {
    brochureUrl
  } = tracks ? getMetadataLanguageFallback(tracks[0].metadata, language) : {
    brochureUrl: DEFAULT_BROCHURE_URL
  };
  const maybeTrackedSrc = !inModal && src && !src.match(/^data:/) ? addUrlParams(src, {
    onAchievementsPage: true
  }) : src;
  if (!publicAchievement || !maybeTrackedSrc && !trackId) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "cert-image-wrapper",
      style: {
        aspectRatio: '4/3'
      },
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        title: I18n.text('learningCenter.certification.errors.noCertSrcTitle'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.certification.errors.noCertSrc"
        })
      })
    });
  }
  const courseLink = addUrlParams(brochureUrl, {
    'hubs_content-cta': 'achievement-cta-cert-image'
  });
  const Container = getMarketingThemePreference() ? MarketingContainer : LegacyContainer;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Hoverlay, {
      foregroundContent: /*#__PURE__*/_jsx(CourseLink, {
        href: courseLink,
        trackEvent: trackEvent
      }),
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "cert-image-wrapper",
        style: {
          aspectRatio: '4/3'
        },
        children: /*#__PURE__*/_jsx(ImageLoader, Object.assign({}, publicAchievement.visibilityType === 'PRIVATE' ? {
          trackId,
          component: PrivateCertificateImage,
          key: trackId
        } : {
          src: maybeTrackedSrc,
          key: maybeTrackedSrc
        }, {
          alt: I18n.text('learningCenter.certification.altText'),
          errorComponent: /*#__PURE__*/_jsx(TFlex, {
            alignItems: "center",
            blockSize: "100%",
            justifyContent: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.certification.errors.imgLoadingError"
            })
          }),
          onError: handleImageError
        }))
      })
    })
  });
};
export default CertificateImage;